/*eslint-disable */

import { bus } from '@/main';

const updateGroupName = () => import('@/components/private/workspace/update-group-name/');
const updateGroupInfo = () => import('@/components/private/workspace/update-group-info/');
const updateGroupIcon = () => import('@/components/private/workspace/update-group-icon/');
const removeUserPopup = () => import('@/components/private/workspace/remove-user-from-group/');
const leaveGroupPopup = () => import('@/components/private/workspace/user-leave-group-popup/');
const makeAdminPopup = () => import('@/components/private/workspace/user-make-admin-popup/');
const dismissAdminPopup = () => import('@/components/private/workspace/dismiss-admin-permission-popup/');
const deleteGroupPopup = () => import('@/components/private/workspace/delete-group-popop/');

export default {
  name: 'group-info-preview-popup',
  components: {},
  props: ["selectedRoomInfo"],
  components: {
    'update-group-info': updateGroupInfo,
    'update-group-name': updateGroupName,
    'update-group-icon': updateGroupIcon,
    'remove-user-popup': removeUserPopup,
    'leave-group-popup': leaveGroupPopup,
    'make-admin-popup': makeAdminPopup,
    'dismiss-admin-popup': dismissAdminPopup,
    'delete-group-popup': deleteGroupPopup
  },
  data() {
    return {
      selfUserId: '',
      updateGroupInfoPopup: false,
      leaveGroupPopupState: false,
      deleteGroupInfoPopup: false,
      makeUsrToAdminPopupState: false,
      userInfo: null,
      removeUserPopupState: false,
      updateGroupNamePopup: false,
      updateGroupIconPopup: false,
      selfUserId: localStorage.getItem('LoginedUserID'),
      groupInfo: this.selectedRoomInfo,
      dismissAdminPermissionState: false,
    }
  },
  computed: {

  },
  mounted() {
    bus.$on('updateGroupInfoDataBus', (data) => {
      this.groupInfo = data;
    });
    bus.$on('updateGroupIconPopupStateBus', (data) => {
      this.updateGroupIconPopup = data;
    });
    bus.$on('updateGroupInfoPopupStateBus', (data) => {
      this.updateGroupInfoPopup = data;
    });
    bus.$on('updateGroupNamePopupStateBus', (data) => {
      this.updateGroupNamePopup = data;
    });
    bus.$on('updateGroupNamePopupStateBus', (data) => {
      this.updateGroupNamePopup = data;
    });
    bus.$on('removeUserPopupStateBus', (data) => {
      this.removeUserPopupState = data;
    });
    bus.$on('leaveGroupPopupStateBus', (data) => {
      this.leaveGroupPopupState = data;
    });
    bus.$on('makeUsrToAdminPopupStateBus', (data) => {
      this.makeUsrToAdminPopupState = data;
    });
    bus.$on('dismissAdminPermissionStateBus', (data) => {
      this.dismissAdminPermissionState = data;
    });
    bus.$on('deleteGroupInfoPopupBus', (data) => {
      this.deleteGroupInfoPopup = data;
    });
  },
  methods: {
    groupSomeInfoDisabled() {
      bus.$emit('groupInfoStateBus', false);
    },
    
    checkTheGroupAdminAccessFun(groupData) {
      for (var i = 0; i < groupData.length; i++) {
        if (groupData[i].user.id == this.selfUserId) {
          return groupData[i].is_admin;
        }
      }
    },
    
    removedUserPopupMethod(userInfo) {
      this.removeUserPopupState = true;
      this.userInfo = userInfo;
    },
    
    dismissAdminPermissionMethod(userInfo) {
      this.dismissAdminPermissionState = true;
      this.userInfo = userInfo;
    },

    makeUserToAdminMethod(userInfo) {
      this.makeUsrToAdminPopupState = true;
      this.userInfo = userInfo;
    },

    updateGroupIconPopupFun() {
      this.updateGroupIconPopup = true;
    },

    updateGroupInfoPopupFun() {
      this.updateGroupInfoPopup = true;
    },

    leaveGroupPopupMethod(){
      this.leaveGroupPopupState = true;
    },

    deleteGroupRoomPopupOpned() {
      this.deleteGroupInfoPopup = true;
    },
    
    updateGroupNamePopupFun() {
      this.updateGroupNamePopup = true;
    },
  }
}